import React from 'react';
import {useTranslation} from 'react-i18next';
import LanguageSelection from 'components/ModalSheets/LanguageSelection';
import {LanguageSelectionRef} from 'components/ModalSheets/LanguageSelection/LanguageSelection';
import {ContainerFooter, StyledButton} from '../styled';
import {Globe, Lock} from 'lucide-react';

function Footer() {
  const {t} = useTranslation();
  const languageSelectionModalRef = React.useRef<LanguageSelectionRef>(null);

  return (
    <ContainerFooter>
      <StyledButton
        onClick={() =>
          window.open(t('guest_privacy_policy_link'), '_blank', 'noopener,noreferrer')
        }
        variant="link"
      >
        <Lock size={16} />
        {t('privacy_policy')}
      </StyledButton>
      <StyledButton
        onClick={() => languageSelectionModalRef?.current?.open()}
        variant="link"
      >
        <Globe size={16} />
        {t('language')}
      </StyledButton>
      <LanguageSelection ref={languageSelectionModalRef} />
    </ContainerFooter>
  );
}

export {Footer};
